export default __webpack_public_path__ + "static/media/ucp.dd4a65a9.jpg";